'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import * as AssetTypes from 'DesignData/enums/DesignAssetTypes';
import * as appSelectors from 'DesignData/selectors/app';
import { byId as TemplateTypes } from 'ContentUtils/constants/TemplateTypes';
import LayoutPropTypes from 'DesignData/propTypes/layouts';
import { getRawAssetPath } from 'DesignData/selectors/rawAssetBuffers';
import * as RawAssetExtensions from 'DesignData/enums/RawAssetExtensions';
import { makeGetTemplateType } from 'DesignData/selectors/templateBuffers';
import TemplatePropTypes from 'DesignData/propTypes/templates';
import StatusBarSection from 'DesignComponents/statusBar/StatusBarSection';

class StatusBarFileType extends PureComponent {
  constructor(...args) {
    super(...args);

    this.generateRawAssetKey = () => {
      const {
        rawAssetPath
      } = this.props;

      if (!rawAssetPath) {
        return 'fileTypes.default';
      }

      const fileExtension = rawAssetPath.split('.').pop();
      const rawAssetExtension = RawAssetExtensions[fileExtension || 'TXT'];

      if (rawAssetExtension && rawAssetExtension.name) {
        return `fileTypes.${rawAssetExtension.name.toLowerCase()}`;
      }

      return 'fileTypes.default';
    };

    this.generateTemplateKey = assetType => {
      const {
        templateType
      } = this.props;
      if (assetType === 'layout' && !templateType) return 'layout';

      if (assetType === 'template' && templateType !== 0 && !templateType) {
        return null;
      }

      const templateTypeInfo = TemplateTypes[templateType];
      if (!templateTypeInfo) return null;
      const {
        name: templateTypeKey
      } = templateTypeInfo;

      switch (assetType) {
        case 'layout':
          return `templateTypes.${templateTypeKey}`;

        case 'template':
          switch (templateTypeKey) {
            case 'css':
              return 'hubl-css';

            case 'js':
              return 'hubl-js';

            default:
              return 'template';
          }

        default:
          return null;
      }
    };
  }

  render() {
    const {
      assetType
    } = this.props;
    let fileType = null;

    switch (assetType) {
      case AssetTypes.CUSTOM_WIDGET:
        {
          fileType = 'customWidget';
          break;
        }

      case AssetTypes.GLOBAL_WIDGET:
        {
          fileType = 'globalWidget';
          break;
        }

      case AssetTypes.LAYOUT:
        {
          fileType = this.generateTemplateKey('layout');
          break;
        }

      case AssetTypes.TEMPLATE:
        {
          fileType = this.generateTemplateKey('template');
          break;
        }

      case AssetTypes.SETTINGS:
        {
          fileType = 'settings';
          break;
        }

      case AssetTypes.WELCOME:
        {
          fileType = 'welcome';
          break;
        }

      case AssetTypes.GETTING_STARTED:
        {
          fileType = 'gettingStarted';
          break;
        }

      case AssetTypes.RAW_ASSET:
        {
          fileType = this.generateRawAssetKey();
          break;
        }

      default:
        break;
    }

    if (!fileType) return null;

    const fileLabel = /*#__PURE__*/_jsx(FormattedMessage, {
      message: `DesignEditorsUI.editorFileTypes.${fileType}`
    });

    return /*#__PURE__*/_jsx(StatusBarSection, {
      label: fileLabel
    });
  }

}

StatusBarFileType.propTypes = {
  templateType: PropTypes.oneOfType([LayoutPropTypes.templateType, TemplatePropTypes.templateId]),
  assetType: PropTypes.oneOf(Object.values(AssetTypes)),
  rawAssetPath: PropTypes.string
};

const mapStateToProps = state => {
  const assetId = appSelectors.getActiveAssetId(state);
  const getTemplateType = makeGetTemplateType();
  return {
    assetType: appSelectors.getActiveAssetType(state),
    templateType: getTemplateType(state, {
      assetId
    }),
    rawAssetPath: getRawAssetPath(state, {
      assetId
    })
  };
};

export default connect(mapStateToProps, null)(StatusBarFileType);